/* ═══════════════════════════════════════════════════════
   THE GADGETS MINK — SHOPIFY THEME JS
   File: assets/theme.js
═══════════════════════════════════════════════════════ */

/* ── PAYMENT WIDGET ── */
function selectPaymentOption(type) {
  var codEl   = document.getElementById('payOptCod');
  var prepEl  = document.getElementById('payOptPrepaid');
  var propEl  = document.getElementById('paymentMethodProp');
  var buyBtn  = document.getElementById('buyNowBtn');
  if (!codEl || !prepEl) return;

  // Remove selected from both
  codEl.classList.remove('payment-option--selected');
  prepEl.classList.remove('payment-option--selected');

  if (type === 'cod') {
    codEl.classList.add('payment-option--selected');
    if (propEl) propEl.value = 'Partial COD';
    // Buy Now becomes "COD Checkout" — still submits form to checkout
    if (buyBtn) {
      buyBtn.style.background = 'var(--accent-gold)';
      buyBtn.style.color = 'var(--charcoal)';
      buyBtn.textContent = '🏠 Checkout with COD';
    }
  } else {
    prepEl.classList.add('payment-option--selected');
    if (propEl) propEl.value = 'Prepaid';
    if (buyBtn) {
      buyBtn.style.background = '';
      buyBtn.style.color = '';
      buyBtn.textContent = '⚡ Buy Now';
    }
  }
}
function openMobileNav() {
  document.getElementById('mobileNav').classList.add('open');
  document.getElementById('mobileOverlay').classList.add('open');
  document.body.style.overflow = 'hidden';
}
function closeMobileNav() {
  document.getElementById('mobileNav').classList.remove('open');
  document.getElementById('mobileOverlay').classList.remove('open');
  document.body.style.overflow = '';
}
function toggleMobileSub(btn) {
  var sub = btn.nextElementSibling;
  var isOpen = sub.classList.contains('open');
  // Close all other subs
  document.querySelectorAll('.mobile-sub').forEach(function(s) { s.classList.remove('open'); });
  document.querySelectorAll('.mobile-expand').forEach(function(b) { b.classList.remove('open'); });
  if (!isOpen) {
    sub.classList.add('open');
    btn.classList.add('open');
  }
}

/* ── SEARCH MODAL ── */
function openSearch() {
  var modal = document.getElementById('searchModal');
  modal.style.display = 'flex';
  setTimeout(function() {
    var input = document.getElementById('searchInput');
    if (input) input.focus();
  }, 100);
  document.body.style.overflow = 'hidden';
}
function closeSearch() {
  document.getElementById('searchModal').style.display = 'none';
  document.body.style.overflow = '';
}
document.addEventListener('keydown', function(e) {
  var inInput = e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA' || e.target.tagName === 'SELECT' || e.target.isContentEditable;
  if (e.key === 'Escape') {
    closeSearch();
    closeMobileNav();
  }
  // Open search with Ctrl+K or / (but not when typing in a field)
  if ((e.ctrlKey || e.metaKey) && e.key === 'k') {
    e.preventDefault();
    openSearch();
  }
  if (e.key === '/' && !inInput && !(e.ctrlKey || e.metaKey)) {
    e.preventDefault();
    openSearch();
  }
});

/* ── CART AJAX ADD ── */
function showCartNotif(msg) {
  var notif = document.getElementById('cartNotif');
  var msgEl = document.getElementById('cartNotifMsg');
  if (!notif || !msgEl) return;
  msgEl.textContent = msg || '✓ Added to cart!';
  notif.style.display = 'flex';
  clearTimeout(window._cartNotifTimer);
  window._cartNotifTimer = setTimeout(function() {
    notif.style.display = 'none';
  }, 4000);
}

function updateCartBadge(count) {
  var badge = document.getElementById('cartCount');
  if (!badge) return;
  if (count > 0) {
    badge.textContent = count;
    badge.style.display = 'flex';
  } else {
    badge.style.display = 'none';
  }
}

function quickAddToCart(variantId, btn) {
  if (!variantId) { alert('Please select options first.'); return; }
  var origText = btn ? btn.innerHTML : '';
  if (btn) { btn.innerHTML = '⏳ Adding...'; btn.disabled = true; btn.classList.add('loading'); }

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(function(res) { return res.json(); })
  .then(function(data) {
    if (data.status && data.status !== 200) {
      alert(data.description || 'Error adding to cart.');
      if (btn) { btn.innerHTML = origText; btn.disabled = false; btn.classList.remove('loading'); }
      return;
    }
    // Update cart count
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) { updateCartBadge(cart.item_count); });
    showCartNotif('✓ ' + (data.title || 'Item') + ' added to cart!');
    if (btn) {
      btn.innerHTML = '✓ Added!';
      btn.style.background = 'var(--brand-green)';
      setTimeout(function() {
        btn.innerHTML = origText;
        btn.disabled = false;
        btn.classList.remove('loading');
        btn.style.background = '';
      }, 2000);
    }
  })
  .catch(function() {
    alert('Could not add to cart. Please try again.');
    if (btn) { btn.innerHTML = origText; btn.disabled = false; btn.classList.remove('loading'); }
  });
}

/* ── PRODUCT PAGE ── */
// Switch gallery image
function switchImage(src, thumb) {
  var main = document.getElementById('mainImage');
  if (main) main.src = src;
  document.querySelectorAll('.gallery-thumb').forEach(function(t) { t.classList.remove('active'); });
  if (thumb) thumb.classList.add('active');
}

// Quantity
function changeQty(delta) {
  var input = document.getElementById('qtyInput');
  if (!input) return;
  var val = Math.max(1, parseInt(input.value || 1) + delta);
  input.value = val;
}


// Dropdown variant selection handler
function selectVariantFromDropdown(optionIndex, value) {
  updateVariantId();
}

// Variant selection + price update (dropdown-based)
function updateVariantId() {
  var variantsData = window.__productVariants;
  if (!variantsData || !variantsData.length) return;

  // Read values from all .variant-dropdown selects
  var selectedOptions = [];
  document.querySelectorAll('.variant-dropdown').forEach(function(dd) {
    selectedOptions.push(dd.value);
  });

  // Find matching variant
  var matched = null;
  for (var i = 0; i < variantsData.length; i++) {
    var v = variantsData[i];
    var opts = [v.option1, v.option2, v.option3].filter(function(o) { return o !== null && o !== undefined; });
    var isMatch = selectedOptions.every(function(sel, idx) { return opts[idx] === sel; });
    if (isMatch) { matched = v; break; }
  }

  if (matched) {
    var hiddenId = document.getElementById('variantId');
    if (hiddenId) hiddenId.value = matched.id;

    // Update URL with selected variant ID
    if (window.history && window.history.replaceState) {
      var urlObj = new URL(window.location.href);
      urlObj.searchParams.set('variant', matched.id);
      window.history.replaceState({}, '', urlObj.toString());
    }

    // Update main image + gallery thumb when variant has a featured image
    if (matched.featured_image && matched.featured_image.src) {
      var rawSrc = matched.featured_image.src.split('?')[0];
      var mainImg = document.getElementById('mainImage');
      if (mainImg) mainImg.src = rawSrc + '?width=900';

      // Highlight the matching thumb, remove active from others
      var allThumbs = document.querySelectorAll('.gallery-thumb');
      allThumbs.forEach(function(t) { t.classList.remove('active'); });
      allThumbs.forEach(function(t) {
        var tImg = t.querySelector('img');
        if (tImg && tImg.src.split('?')[0] === rawSrc) {
          t.classList.add('active');
        }
      });
    }

    var priceEl = document.querySelector('#productPrice');
    var origEl = document.querySelector('#productOriginalPrice');
    if (priceEl) priceEl.textContent = formatMoney(matched.price);
    if (origEl) {
      if (matched.compare_at_price && matched.compare_at_price > matched.price) {
        origEl.textContent = formatMoney(matched.compare_at_price);
        origEl.style.display = '';
      } else {
        origEl.style.display = 'none';
      }
    }
    // Sync payment widget price
    var pwPrice = document.getElementById('paymentWidgetPrice');
    var pwCodPrice = document.getElementById('paymentWidgetCodPrice');
    if (window.__isPrisma1499) {
      // Prisma products: prepaid stays fixed at Rs. 999 (discounted price),
      // only COD price updates to reflect the selected variant's price
      if (pwPrice) pwPrice.textContent = 'Rs. 999.00';
      if (pwCodPrice) pwCodPrice.textContent = formatMoney(matched.price);
    } else {
      // Regular products: prepaid price updates with variant price
      if (pwPrice) pwPrice.textContent = formatMoney(matched.price);
      // COD price is a fixed label (e.g. "Pay Rs.99 now") — do NOT overwrite it
    }

    var atcBtn = document.getElementById('atcBtn');
    var unavailableNote = document.getElementById('unavailableNote');
    if (matched.available) {
      if (atcBtn) {
        atcBtn.disabled = false;
        // Bug 5 Fix: Read label from data attribute set by Liquid, don't hardcode
        atcBtn.textContent = atcBtn.dataset.atcLabel || '🛒 Add to Cart';
      }
      if (unavailableNote) unavailableNote.style.display = 'none';
    } else {
      if (atcBtn) {
        atcBtn.disabled = true;
        atcBtn.textContent = atcBtn.dataset.oosLabel || 'Out of Stock';
      }
      if (unavailableNote) unavailableNote.style.display = 'block';
    }
  }
}

// Product page ATC form submit — AJAX add then redirect or show notification
document.addEventListener('DOMContentLoaded', function() {
  var productForm = document.getElementById('ProductForm');
  if (productForm) {
    productForm.addEventListener('submit', function(e) {
      var isCheckout = e.submitter && e.submitter.name === 'checkout';
      if (isCheckout) return; // Let Buy Now go normally

      e.preventDefault();
      var atcBtn = document.getElementById('atcBtn');
      var variantId = document.getElementById('variantId');
      var qtyInput = document.getElementById('qtyInput');
      var qty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;
      var id = variantId ? variantId.value : null;
      if (!id) { alert('Please select a variant.'); return; }

      var origText = atcBtn ? atcBtn.innerHTML : '';
      if (atcBtn) { atcBtn.innerHTML = '⏳ Adding...'; atcBtn.disabled = true; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: id, quantity: qty })
      })
      .then(function(res) { return res.json(); })
      .then(function(data) {
        if (data.status && data.status !== 200) {
          alert(data.description || 'Error adding to cart.');
          if (atcBtn) { atcBtn.innerHTML = origText; atcBtn.disabled = false; }
          return;
        }
        fetch('/cart.js')
          .then(function(r) { return r.json(); })
          .then(function(cart) { updateCartBadge(cart.item_count); });
        showCartNotif('✓ Added to cart!');
        if (atcBtn) {
          atcBtn.innerHTML = '✓ Added!';
          atcBtn.style.background = 'var(--brand-green)';
          setTimeout(function() {
            atcBtn.innerHTML = origText;
            atcBtn.disabled = false;
            atcBtn.style.background = '';
          }, 2000);
        }
      })
      .catch(function() {
        alert('Could not add to cart. Please try again.');
        if (atcBtn) { atcBtn.innerHTML = origText; atcBtn.disabled = false; }
      });
    });
  }
});

// Format money using store's Shopify money format (Bug 13 Fix)
function formatMoney(cents) {
  if (window.Shopify && window.Shopify.formatMoney) {
    return window.Shopify.formatMoney(cents, window.MONEY_FORMAT);
  }
  // Fallback using store's MONEY_FORMAT if available
  var format = window.MONEY_FORMAT || '₹{{amount}}';
  var amount = (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return format.replace('{{amount}}', amount).replace('{{amount_no_decimals}}', Math.floor(cents/100));
}

/* ── PRODUCT TABS ── */
function switchTab(id, btn) {
  document.querySelectorAll('.tab-panel').forEach(function(p) { p.classList.remove('active'); });
  document.querySelectorAll('.tab-btn').forEach(function(b) { b.classList.remove('active'); });
  var panel = document.getElementById('tab-' + id);
  if (panel) panel.classList.add('active');
  if (btn) btn.classList.add('active');
}

/* ── WISHLIST (localStorage persistence — Bug 10 Fix) ── */
function _getWishlist() {
  try { return JSON.parse(localStorage.getItem('gm_wishlist') || '[]'); } catch(e) { return []; }
}
function _saveWishlist(list) {
  try { localStorage.setItem('gm_wishlist', JSON.stringify(list)); } catch(e) {}
}
function toggleWishlist(btn) {
  var productId = btn.dataset.productId || btn.closest('[data-product-id]') && btn.closest('[data-product-id]').dataset.productId;
  var isWished = btn.classList.contains('wishlisted');
  btn.classList.toggle('wishlisted');
  btn.textContent = isWished ? '♡' : '♥';
  btn.style.color = isWished ? '' : '#E85D35';
  if (productId) {
    var list = _getWishlist();
    if (isWished) { list = list.filter(function(id) { return id !== productId; }); }
    else if (list.indexOf(productId) === -1) { list.push(productId); }
    _saveWishlist(list);
  }
}
function toggleWishlistFull(btn) {
  var productId = btn.dataset.productId;
  var isWished = btn.innerHTML.includes('♥');
  if (!isWished) {
    btn.innerHTML = '♥ &nbsp;Saved to Wishlist';
    btn.style.color = '#E85D35';
    btn.style.borderColor = '#E85D35';
  } else {
    btn.innerHTML = '♡ &nbsp;Save to Wishlist';
    btn.style.color = '';
    btn.style.borderColor = '';
  }
  if (productId) {
    var list = _getWishlist();
    if (isWished) { list = list.filter(function(id) { return id !== productId; }); }
    else if (list.indexOf(productId) === -1) { list.push(productId); }
    _saveWishlist(list);
  }
}
// Restore wishlist state on page load
document.addEventListener('DOMContentLoaded', function() {
  var list = _getWishlist();
  if (!list.length) return;
  document.querySelectorAll('[data-product-id]').forEach(function(el) {
    if (list.indexOf(el.dataset.productId) !== -1) {
      var btn = el.querySelector('.prod-wishlist');
      if (btn) { btn.classList.add('wishlisted'); btn.textContent = '♥'; btn.style.color = '#E85D35'; }
    }
  });
});

/* ── COLLECTION PAGE ── */
function setGrid(cols, btn) {
  document.querySelectorAll('.view-btn').forEach(function(b) { b.classList.remove('active'); });
  if (btn) btn.classList.add('active');
  var grid = document.getElementById('productsGrid');
  if (!grid) return;
  grid.classList.remove('two-col', 'four-col');
  if (cols === 2) grid.classList.add('two-col');
  if (cols === 4) grid.classList.add('four-col');
}

function handleSort(value) {
  var url = new URL(window.location.href);
  url.searchParams.set('sort_by', value);
  window.location.href = url.toString();
}

function setDesignTab(btn, filter) {
  document.querySelectorAll('.design-tab').forEach(function(b) { b.classList.remove('active'); });
  if (btn) btn.classList.add('active');
  // Bug 1 Fix: Actually filter products by navigating to tagged URL
  if (!filter || filter === 'all') {
    var base = window.location.pathname.split('/tagged/')[0];
    window.location.href = base;
  } else {
    var base = window.location.pathname.split('/tagged/')[0];
    window.location.href = base + '/tagged/' + encodeURIComponent(filter);
  }
}

function clearFilters() {
  // Bug 14 Fix: Navigate to clean collection URL to actually clear Shopify tag filters
  var cleanUrl = window.location.pathname.split('/tagged/')[0];
  var url = new URL(window.location.href);
  url.searchParams.delete('sort_by');
  window.location.href = cleanUrl + (url.search ? url.search : '');
}

/* ── AUTH PAGE TABS ── */
function switchAuthTab(tab) {
  document.querySelectorAll('.auth-tab-btn').forEach(function(b) { b.classList.remove('active'); });
  document.querySelectorAll('.auth-tab-panel').forEach(function(p) { p.classList.remove('active'); });
  document.querySelector('[data-tab="' + tab + '"]').classList.add('active');
  document.getElementById('auth-panel-' + tab).classList.add('active');
}

/* ── COPY COUPON CODE ── */
function copyCoupon(code) {
  navigator.clipboard.writeText(code).then(function() {
    showCartNotif('✓ Coupon "' + code + '" copied!');
  }).catch(function() {
    // Fallback
    var ta = document.createElement('textarea');
    ta.value = code;
    document.body.appendChild(ta);
    ta.select();
    document.execCommand('copy');
    document.body.removeChild(ta);
    showCartNotif('✓ Coupon "' + code + '" copied!');
  });
}

/* ── CART AJAX REMOVE (Bug 12 Fix) ── */
function removeCartItem(key, btn) {
  if (btn) { btn.disabled = true; btn.style.opacity = '0.4'; }
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: key, quantity: 0 })
  })
  .then(function(r) { return r.json(); })
  .then(function(cart) {
    updateCartBadge(cart.item_count);
    // Reload the cart section to reflect removal
    window.location.reload();
  })
  .catch(function() {
    if (btn) { btn.disabled = false; btn.style.opacity = ''; }
    alert('Could not remove item. Please try again.');
  });
}


function applyCartCoupon() {
  var input = document.getElementById('cartCouponInput');
  if (!input) return;
  var code = input.value.trim();
  if (!code) { showCartNotif('⚠ Please enter a coupon code.'); return; }
  // Shopify applies discounts via /discount/CODE redirect
  window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
}

/* ── CART QTY DEBOUNCE (Bug 12 Fix) ── */
(function() {
  var _cartDebounceTimer = null;
  document.addEventListener('change', function(e) {
    var el = e.target;
    if (el && el.name === 'updates[]') {
      clearTimeout(_cartDebounceTimer);
      _cartDebounceTimer = setTimeout(function() {
        el.form && el.form.submit();
      }, 400);
      e.stopImmediatePropagation();
    }
  }, true);
})();

/* ── TAG FILTER MULTI-SELECT (Bug 7 Fix) ── */
function applyTagFilters(collectionUrl) {
  var checked = [];
  document.querySelectorAll('.filter-opt input[data-tag]:checked').forEach(function(el) {
    checked.push(el.dataset.tag);
  });
  if (checked.length === 0) {
    window.location.href = collectionUrl;
  } else {
    // Shopify supports /collections/handle/tag1+tag2 for AND, or separate navigations
    window.location.href = collectionUrl + '/' + checked.join('+');
  }
}

/* ── PRICE RANGE FILTER (Bug 2 Fix) ── */
function applyPriceFilter(min, max) {
  var url = new URL(window.location.href);
  url.searchParams.set('filter.p.price.gte', min);
  url.searchParams.set('filter.p.price.lte', max);
  window.location.href = url.toString();
}
